import React from 'react';

import PropTypes from 'prop-types';

const PublishedOn = (props) => {
    const { children } = props;
    return <span>Published on {children}</span>;
};

PublishedOn.propTypes = {
    children: PropTypes.node,
};

export default PublishedOn;
